(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["k24-active-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const filters = document.querySelector('.k24-collection__filter--container');
    const openBtn = e.target.closest('#filters-open');

    if (openBtn) {
      e.preventDefault();
      filters.classList.toggle('active');
      return;
    }else{
      return;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-item"] && !Shopify.designMode) return;
  try {
    (function () {
    const quantityContainers = document.querySelectorAll('.quantity');

    quantityContainers.forEach((quantityContainer) => {
      const minusBtn = quantityContainer.querySelector('.minus');
      const plusBtn = quantityContainer.querySelector('.plus');
      const inputBox = quantityContainer.querySelector('.input-box');

      if (!inputBox) return;

      const min = parseInt(inputBox.min || 1);
      const updateBtn = quantityContainer.closest('.line-item')?.querySelector('input[type="submit"]');

      updateButtonStates();
      quantityContainer.addEventListener('click', handleButtonClick);
      inputBox.addEventListener('input', handleQuantityChange);

      function updateButtonStates() {
        const value = parseInt(inputBox.value);
        minusBtn.disabled = value <= min;
        plusBtn.disabled = value >= parseInt(inputBox.max || 999);
      }

      function handleButtonClick(event) {
        if (event.target.classList.contains('minus')) {
          event.preventDefault();
          decreaseValue();
        } else if (event.target.classList.contains('plus')) {
          event.preventDefault();
          increaseValue();
        }
      }

      function decreaseValue() {
        let value = parseInt(inputBox.value);
        value = isNaN(value) ? min : Math.max(value - 1, min);
        inputBox.value = value;
        updateButtonStates();
        handleQuantityChange();
      }

      function increaseValue() {
        let value = parseInt(inputBox.value);
        const max = parseInt(inputBox.max || 999);
        value = isNaN(value) ? min : Math.min(value + 1, max);
        inputBox.value = value;
        updateButtonStates();
        handleQuantityChange();
      }

      function handleQuantityChange() {
        let value = parseInt(inputBox.value);
        value = isNaN(value) ? min : Math.max(value, min);
        inputBox.value = value;
        updateButtonStates();

        if (updateBtn) {
          updateBtn.click();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-custom-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
      const select = event.target.closest('select[data-option-id]');
      if (!select) return;

      const optionId = select.dataset.optionId;
      const selected = select.options[select.selectedIndex];
      const target = document.querySelector('[data-option-meta-target="' + optionId + '"]');

      if (!target || !selected) return;

      target.value = JSON.stringify({
        optionId: optionId,
        valueId: selected.dataset.valueId || null,
        title: selected.value || '',
        price: parseFloat(selected.dataset.price || '0'),
        percentage: parseFloat(selected.dataset.percentage || '0')
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-header"] && !Shopify.designMode) return;
  try {
    (function () {
    const quantityContainer = document.querySelector('.quantity');
    const minusBtn = quantityContainer.querySelector('.minus');
    const plusBtn = quantityContainer.querySelector('.plus');
    const inputBox = quantityContainer.querySelector('.input-box');
    const min = parseInt(inputBox.min || 1);

    updateButtonStates();

    quantityContainer.addEventListener('click', handleButtonClick);
    inputBox.addEventListener('input', handleQuantityChange);

    function updateButtonStates() {
      const value = parseInt(inputBox.value);
      minusBtn.disabled = value <= min;
      plusBtn.disabled = value >= parseInt(inputBox.max || 999);
    }

    function handleButtonClick(event) {
      event.preventDefault();
      if (event.target.classList.contains('minus')) {
        decreaseValue();
      } else if (event.target.classList.contains('plus')) {
        increaseValue();
      }
    }

    function decreaseValue() {
      let value = parseInt(inputBox.value);
      value = isNaN(value) ? min : Math.max(value - 1, min);
      inputBox.value = value;
      updateButtonStates();
      dispatchQuantityEvents();
    }

    function increaseValue() {
      let value = parseInt(inputBox.value);
      value = isNaN(value) ? min : Math.min(value + 1, parseInt(inputBox.max || 999));
      inputBox.value = value;
      updateButtonStates();
      dispatchQuantityEvents();
    }

    function handleQuantityChange() {
      const max = parseInt(inputBox.max || 999);
      let value = parseInt(inputBox.value);
      value = isNaN(value) ? min : Math.min(Math.max(value, min), max);
      inputBox.value = value;
      updateButtonStates();
    }

    // De buttons zetten inputBox.value programmatisch, wat geen native events
    // afvuurt. Externe apps (custom velden e.d.) luisteren op input/change, dus
    // dispatchen we die hier expliciet. Niet aanroepen vanuit de input-listener,
    // anders ontstaat een lus.
    function dispatchQuantityEvents() {
      inputBox.dispatchEvent(new Event('input', { bubbles: true }));
      inputBox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
